
      import Refresh from './refresh.vue'
      import type { App, Plugin } from 'vue'

      export const RefreshPlugin: Plugin = {
        install(app: App) {
          app.component('Refresh', Refresh)
        },
      }
      export { Refresh }
      